import {Form} from 'semantic-ui-react';
import styled, {css} from 'styled-components';

const InputMix = css`
    & > label {
        color: #ffffff !important;
        font-family: Roboto, sans-serif !important;
        font-size: 10px !important;
        font-weight: bold !important;
        letter-spacing: 0.62px !important;
        line-height: .8rem !important;
        margin-left: 1.4rem !important;
    }
    & > .ui.input {
        & > input {
                height: 52px;
                border: 1px solid #FFFFFF !important;
                border-radius: 5px !important;
                background-color: rgba(255,255,255,0.2) !important;
                color: #ffffff !important;
                font-family: Roboto, sans-serif !important;
                font-size: 1rem !important;
                font-weight: 500 !important;
                letter-spacing: 0.88px !important;
                &::placeholder {
                    color: #ffffff !important;
                    font-family: Roboto, sans-serif !important;
                    font-size: 14px !important;
                    font-weight: normal !important;
                    letter-spacing: 0.62px !important;
                    line-height: .8rem !important;
                }
            }
        }
    }
`;

export const FormInputLogin = styled(Form.Input)`${InputMix}`;
export const FormSelectLogin = styled(Form.Select)`${InputMix}`;



// WEBPACK FOOTER //
// ./src/components/Form/FormInputMix.js